import React, { useState } from 'react';
import { Phone, Mail, MapPin, Send } from 'lucide-react';
const BG = 'https://cdn.magicpatterns.com/patterns/generated-images/c3a95225-5ee1-49b1-97e8-92cbf66d93eb.jpg';
export function ContactCTA() {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <section id="contact" className="relative isolate w-full overflow-hidden py-20 lg:py-28" data-id="element-11" data-mp="1mqsf8sg53krm">
      <img src={BG} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" data-id="element-12" data-mp="1htaehpca0bup" />
      <div className="absolute inset-0 bg-background/90" aria-hidden="true" data-id="element-13" data-mp="1vsie2jccplzf" />

      <div className="relative mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8" data-id="element-14" data-mp="1rqwu6e1eg7fq">
        <div data-id="element-15" data-mp="376vwv9s8zb8l">
          <span className="font-display text-lg tracking-wide text-accent" data-id="element-16" data-mp="376dwc0yjyauv">Get Started</span>
          <h2 className="mt-2 font-display text-4xl leading-tight text-foreground sm:text-5xl" data-id="element-17" data-mp="336lltipllumv">
            Request Your Free Quote
          </h2>
          <p className="mt-4 max-w-md text-lg text-muted-foreground" data-id="element-18" data-mp="ga826bzs327q">
            Tell us about your project and we’ll schedule a no-obligation on-site consultation.
            Most quotes are returned within 24 hours.
          </p>

          <ul className="mt-8 space-y-4" data-id="element-19" data-mp="u8eu7bi1q7zh">
            <li data-id="element-20" data-mp="u7d7g9ro3x1x">
              <a href="tel:+14805550147" className="flex items-center gap-3 text-foreground transition-colors hover:text-accent" data-id="element-21" data-mp="u5skp6blhiem">
                <Phone className="h-5 w-5 text-accent" aria-hidden="true" data-id="element-22" data-mp="1iy2kg292v4b" />
                <span className="font-display text-xl" data-id="element-23" data-mp="1gv2t4bapnme">(480) 555-0147</span>
              </a>
            </li>
            <li data-id="element-24" data-mp="b90wcih74d3p">
              <a href="mailto:info@outdoorlandscapelightingaz.com" className="flex items-center gap-3 text-foreground transition-colors hover:text-accent" data-id="element-25" data-mp="b9ke9z6uj1hq">
                <Mail className="h-5 w-5 text-accent" aria-hidden="true" data-id="element-26" data-mp="39wyd7htslqef" />
                <span data-id="element-27" data-mp="3ewt1req3i3wb">info@outdoorlandscapelightingaz.com</span>
              </a>
            </li>
            <li className="flex items-center gap-3 text-muted-foreground" data-id="element-28" data-mp="m2cdyh9c5z29">
              <MapPin className="h-5 w-5 text-accent" aria-hidden="true" data-id="element-29" data-mp="h5c9gas4x4d9" />
              <span data-id="element-30" data-mp="uvxqrv1xx691">Gilbert, Arizona</span>
            </li>
          </ul>
        </div>

        <div className="rounded-2xl border border-border bg-card p-7 shadow-2xl sm:p-8" data-id="element-31" data-mp="uxs34kz5bq1i">
          {submitted ? <div className="flex h-full min-h-[320px] flex-col items-center justify-center text-center" data-id="element-32" data-mp="34hvzdq8cd7q">
              <div className="flex h-14 w-14 items-center justify-center rounded-full bg-accent text-accent-foreground" data-id="element-33" data-mp="3ubm308mdjzg5">
                <Send className="h-6 w-6" aria-hidden="true" data-id="element-34" data-mp="c6is279q8t7t" />
              </div>
              <h3 className="mt-5 font-display text-2xl text-foreground" data-id="element-35" data-mp="75v45ugsosht">Thanks — we got it!</h3>
              <p className="mt-2 text-muted-foreground" data-id="element-36" data-mp="1nk3dgnck15bi">
                We’ll be in touch within 24 hours to schedule your free consultation.
              </p>
            </div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-37" data-mp="1r20w27qgacqs">
              <div className="grid gap-5 sm:grid-cols-2" data-id="element-38" data-mp="1r4n408h96u9j">
                <Field id="name" label="Name" type="text" placeholder="Jane Smith" data-id="element-39" data-mp="1v56wgyqvt9pc" />
                <Field id="phone" label="Phone" type="tel" placeholder="(480) 555-0000" data-id="element-40" data-mp="1h55z3t9tskem" />
              </div>
              <Field id="email" label="Email" type="email" placeholder="you@email.com" data-id="element-41" data-mp="1m4iksaoynlfm" />
              <Field id="address" label="Property Address" type="text" placeholder="City / neighborhood" required={false} data-id="element-42" data-mp="29srzytro5axs" />
              <div data-id="element-43" data-mp="2eqtmjooazse0">
                <label htmlFor="message" className="mb-1.5 block text-sm font-semibold text-foreground" data-id="element-44" data-mp="2eu7myrdeprit">
                  Project Details
                </label>
                <textarea id="message" rows={4} placeholder="Tell us what you'd like to light up..." className="w-full rounded-md border border-border bg-background px-4 py-3 text-foreground placeholder:text-muted-foreground focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent" data-id="element-45" data-mp="251a1ccd4bmfz" />
              </div>
              <button type="submit" className="w-full rounded-md bg-accent px-6 py-4 font-display text-lg tracking-wide text-accent-foreground transition-transform hover:scale-[1.02]" data-id="element-46" data-mp="14uex98a2t9mj">
                Get My Free Quote
              </button>
            </form>}
        </div>
      </div>
    </section>;
}
function Field({
  id,
  label,
  type,
  placeholder,
  required = true
}: {
  id: string;
  label: string;
  type: string;
  placeholder: string;
  required?: boolean;
}) {
  return <div data-id="element-47" data-mp="1ismr37btfuth">
      <label htmlFor={id} className="mb-1.5 block text-sm font-semibold text-foreground" data-id="element-48" data-mp="1dvw9ugo9yt6h">
        {label}
      </label>
      <input id={id} type={type} required={required} placeholder={placeholder} className="w-full rounded-md border border-border bg-background px-4 py-3 text-foreground placeholder:text-muted-foreground focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent" data-id="element-49" data-mp="2bbs7nh5nhk1f" />
    </div>;
}